import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_TPI_DASHBOARD = gql`
  query GetTPIDashboard($clientId: String) {
    getTPIDashboard(clientId: $clientId) {
      sheets {
        sheetId
        featureTag
      }
      url
      parameters
    }
  }
`;
